import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/connections/page';

export const Route = createFileRoute('/_app/settings/connections/')({
  component: Page,
});
